import {apiClient} from "../utils/Api";

export default class UserCarService {

    static send = (data) => {
        return apiClient.post(`/order/send`, data);
    };

    static create = (data) => {
        return apiClient.post(`/order/create`, data);
    };

    static update = (data) => {
        return apiClient.post(`/order/update`, data);
    };

    static detail = (id) => {
        return apiClient.get('/order/detail?id='+id);
    };

    static findByObjectId = (object_id) => {
        return apiClient.get('/order/findByObjectId?object_id='+object_id);
    };

    static updateBrandId = (data) => {
        return apiClient.post(`/order/update-brand-id`, data);
    }

}